import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { EmployeeCostsService } from "../../employee-costs.service";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";

@Component({
  selector: "app-list-employees-costs",
  templateUrl: "./list-employees-costs.component.html",
  styleUrls: ["./list-employees-costs.component.scss"],
})
export class ListEmployeesCostsComponent implements OnInit {
  public contentHeader: IContentHeader;
  public costsList: any = [];
  public filterKeyword: string = "";
  public filterMonth: number = moment().month();
  public filterYear: number = moment().year();
  public years: number[];
  public months: number[];
  public showRecord: number = -1;

  constructor(
    public _utilsService: UtilsService,
    private _employeeCostsService: EmployeeCostsService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
  ) {
    this.contentHeader = {
      headerTitle: "EMPLOYEE_MONTHLY_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "EMPLOYEE_MONTHLY_COSTS",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_employee_monthly_costs")) {
      return this._router.navigateByUrl("/dashboard/platform-management");
    }
    const year: number = moment().year();
    this.months = Array.from({ length: 12 }, (_, i) => i + 1);
    this.years = [...Array.from({ length: 3 }, (_, i) => year - (i + 1)).reverse(), year, ...Array.from({ length: 2 }, (_, i) => year + (i + 1))];
    await this.getList();
  }

  getMonthName(month: number) {
    return moment()
      .month(month - 1)
      .format("MMMM");
  }

  async getList() {
    this.costsList = await this._employeeCostsService.getMonthlyCosts(this.filterMonth, this.filterYear).then((results: any) => {
      if (this.filterKeyword.length < 1) {
        return results;
      }
      const keyword: string = this.filterKeyword.toLowerCase().trim();
      return results.filter((record: any) => record.complete_name.toLowerCase().includes(keyword));
    });
    this.showRecord = -1;
  }
}
